<template>
  <div id="bottomRight">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <router-link to='/technology'>
         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">技术交易</span>
        </span>
        </router-link>
      </div>
      <div class="item">
        <span><i class="icon-dot" style="color: #ed3f35"></i>技术交易金额</span>
        <h2>{{toThousands(allAmount)}}</h2>元
      </div>
      <div class="d-flex jc-center" style=" margin-top: 0;clear: both;width: 100%">
        <div ref="chart" id="techChart" style="width: 100%;height: 3rem;"></div>
      </div>
    </div>
  </div>
</template>

<script>
let Chart
import sciApi from '@/api/index.js'
export default {
  data() {
    return {
      tag:'',
      option:{},
      Num:{},
      Amount:{},
      allAmount:0,
      allAmountList:[],
    };
  },
  watch: {
    setregion: {
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val

      },
    },
    tag: {
      immediate: false,
      deep: true,
      handler(val) {
        console.log(val, 'val')
        this.init().then(() => {
          let amount=[this.Amount['技术市场'],this.Amount['易智商城']]
          let num=[this.Num['技术市场'],this.Num['易智商城']]
          this.option.series[0].data = amount
          this.option.series[1].data = num
          Chart.setOption(JSON.parse(JSON.stringify(this.option)),true);
        })
      },
    },
  },
  computed:{
    setregion() {
      return this.$store.state.region
    }
  },
  mounted() {
    this.tag=''
    this.init().then(()=>{
      let amount=[this.Amount['技术市场'],this.Amount['易智商城']]
      let num=[this.Num['技术市场'],this.Num['易智商城']]
      this.option.series[0].data=amount
      this.option.series[1].data = num
      Chart.setOption(JSON.parse(JSON.stringify(this.option)),true);
    })
    //政策精要
    this.option = {
      tooltip: {
        // 触发类型  经过轴触发axis  经过轴触发item
        trigger: 'axis',
        // 轴触发提示才有效
        axisPointer: {
          // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果
          type: 'line'
        }
      },
      grid: {
        // 距离 上右下左 的距离
        left: '3%',
        right: '4%',
        bottom: '0',
        top:'8%',
        // 大小是否包含文本【类似于boxsizing】
        containLabel: true,
        //显示边框
        show: false,
        //边框颜色
        borderColor: 'rgba(0, 240, 255, 0.3)'
      },
      yAxis: {
        // 使用类目，必须有data属性
        type: 'value',
        boundaryGap: [0, 0.01],
        // 使用 data 中的数据设为刻度文字

        // 刻度设置
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false
        },
        axisLine:{
          show:true,
          lineStyle:{
            color:'#4c9bfd'
          },

        },
        //文字
        axisLabel: {
          color: '#4c9bfd',
        },
        splitLine: {
          show:false,
          lineStyle: {
            color: '#4c9bfd',
            show:true
          }
        }
      },
      xAxis: {

        // 使用数据的值设为刻度文字
        type: 'category',
        data:['成果转化','易智商城'],
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false

        }, //坐标线
        axisLine:{
          show:true,
          lineStyle:{
            color:'#4c9bfd'
          }},
        //文字
        axisLabel: {
          color: '#4c9bfd',
          fontSize: '14'
        },
        splitLine: {
          show:false,
          lineStyle: {
            color: '#4c9bfd',
            show:true
          }
        },
      },
      series: [{
        name:'交易金额',
        smooth: true,
        barWidth: 25,
        itemStyle: {
          color: '#ed3f35'  // 线颜色
        },
        areaStyle: {
          normal: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              // { offset: 0, color: "#956FD4" },
              // { offset: 1, color: "#3EACE5" }
              { offset: 1, color: "rgba(35,184,210,0.6)" }, // 1 结束颜色
              { offset: 0, color: "rgba(35,184,210,0)" }  // 0 起始颜色
            ])
          }
        },
        label: {
          show: true,
          position: 'top',
          color:'#fff',
          fontSize: 16,
          formatter: "{c}元",
        },
        data:[],
        type: 'line',

      },
        {
          name:'交易笔数',
          data:[],
          type: 'line',
          smooth: true,
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                // { offset: 0, color: "#956FD4" },
                // { offset: 1, color: "#3EACE5" }
                { offset: 1, color: "rgba(35,184,210,0.6)" }, // 1 结束颜色
                { offset: 0, color: "rgba(35,184,210,0)" }  // 0 起始颜色
              ])
            }
          },
          label: {
            show: true,
            position: 'top',
            color:'#fff',
            fontSize: 16,
            formatter: "{c}笔",
          },
          itemStyle: {
            color: '#00f2f1'  // 线颜色
          }
        }
      ]
    }
    this.drawLine();
  },
  methods: {
   toThousands(num) {
  return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
   },
    async init(){
      // await sciApi.selectTechnology({})
      await sciApi.selectTechnology({pageSize: 1000,pageNum: 1}).then((data)=>{
        // data 就是接口返回值
        this.allAmountList = data.list || []
        if(this.tag!==''){
          this.sum = 0
          this.sum1 = 0
          this.sum2 = 0
          this.sum3 = 0
          this.sum4 = 0
          this.allAmountList.forEach((item) => {
            if(item.level1Display=="交易金额" && item.level2Display=="技术市场"){
              this.sum1 += parseInt(item.mapNum||0)
              if (item.mapAreaDisplay == this.tag) {
                this.Amount['技术市场'] = this.sum1
              }else{
                this.Amount['技术市场']= 0
              }
            }
            if(item.level1Display=="交易笔数" && item.level2Display=="技术市场"){
              this.sum2 += parseInt(item.mapNum||0)
              if (item.mapAreaDisplay == this.tag) {
                this.Num['技术市场'] = this.sum2
              }else{
                this.Num['技术市场']= 0
              }
            }
            if(item.level1Display=="交易金额" && item.level2Display=="易智商城"){
              this.sum3 += parseInt(item.mapNum||0)
              if (item.mapAreaDisplay == this.tag) {
                this.Amount['易智商城'] = this.sum3
              }else{
                this.Amount['易智商城']= 0
              }
            }
            if(item.level1Display=="交易笔数" && item.level2Display=="易智商城"){
              this.sum4 += parseInt(item.mapNum||0)
              if (item.mapAreaDisplay == this.tag) {
                this.Num['易智商城'] = this.sum4
              }else{
                this.Num['易智商城']= 0
              }
            }
          })
        }else {
          this.sum = 0
          this.sum1 = 0
          this.sum2 = 0
          this.sum3 = 0
          this.sum4 = 0
          this.allAmountList.forEach((item) => {
            if(item.level1Display=="交易金额"){
              this.sum += parseInt(item.mapNum||0)
              this.allAmount = this.sum
            }
            if(item.level1Display=="交易金额" && item.level2Display=="技术市场") {
              this.sum1 += parseInt(item.mapNum || 0)
              this.Amount['技术市场'] = this.sum1
            }
            if(item.level1Display=="交易笔数" && item.level2Display=="技术市场") {
              this.sum2 += parseInt(item.mapNum || 0)
              this.Num['技术市场'] = this.sum2
            }
            if(item.level1Display=="交易金额" && item.level2Display=="易智商城") {
              this.sum3 += parseInt(item.mapNum || 0)
              this.Amount['易智商城'] = this.sum3
            }
            if(item.level1Display=="交易笔数" && item.level2Display=="易智商城") {
              this.sum4 += parseInt(item.mapNum || 0)
              this.Num['易智商城'] = this.sum4
            }
          })
        }
      })
    },
    drawLine:function (){
      //基于准备好的dom，初始化echarts实例
      Chart = this.$echarts.init(document.getElementById('techChart'))
      // myChart = this.$echarts.init(this.$refs.chart)
      Chart.setOption(JSON.parse(JSON.stringify(this.option)));
      window.test = Chart
    },
    setOption(){
      // if(!myChart.clear) return
      //  myChart.clear()
      //  var setdata={
      //    城口县:[200, 1300, 700, 560, 400],开州区:[20, 130, 70, 56, 40],梁平区:[100,200,300,400,500]}
      //  for(let key in setdata){
      //    if(this.tag == key){
      //      this.option.series[0].data = setdata[key];
      //      console.log(this.option.series)
      //      myChart.setOption(JSON.parse(JSON.stringify(this.option)),true);
      //    }
      //  }
      // option && myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss">
#bottomRight {
  padding: 0.2rem;
  height: 100%;
  width: 100%;
  border-radius: 0.0625rem;
  .bg-color-black {
    height: 5rem;
  }
  .item{
    width: 100%;
    font-size: 16px;
    color: #5cd9e8;
    text-align: left;
    line-height: 40px;
    padding-left: 0.2rem;
  }
  .item h2{
    font-size: 30px;
    color:#fff!important;
    display: inline-block;
    font-weight: normal;
    padding: 0 0.1rem;
  }
  .text {
    color: #c3cbde;
  } //下滑线动态
  .decoration2 {
    position: absolute;
    right: 0.125rem;
  }
  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;
    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
}
</style>